import { combineReducers } from '@reduxjs/toolkit';
import permissionsApi, {
  permissionDialogSlice,
} from './features/findLoads/permissionsState';
import {
  milesServiceApi,
  ordersSlice,
  ryanTransApi,
} from './features/findLoads/state';
import { formDrawerSate } from './features/myLanes/formDrawerState';
import {
  companyApi,
  joyrideSlice,
  loadsCountSlice,
  myLanesApi,
} from './features/myLanes/state';
import { countdownSlice } from './features/quoting/countdownSlice';
import quotingApi, {
  automatedBINSlice,
  quoteSlice,
} from './features/quoting/quotingState';
import feautureFlagApi, { featureFlagSlice } from './state/featureFlagState.';
import { showHighwayRegistrationFlowSlice } from './state/showHighwayRegistrationFlowSlice';

export default combineReducers({
  [myLanesApi.reducerPath]: myLanesApi.reducer,
  [quotingApi.reducerPath]: quotingApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [ryanTransApi.reducerPath]: ryanTransApi.reducer,
  [loadsCountSlice.reducerPath]: loadsCountSlice.reducer,
  [joyrideSlice.reducerPath]: joyrideSlice.reducer,
  [formDrawerSate.reducerPath]: formDrawerSate.reducer,
  [ordersSlice.reducerPath]: ordersSlice.reducer,
  [automatedBINSlice.reducerPath]: automatedBINSlice.reducer,
  [milesServiceApi.reducerPath]: milesServiceApi.reducer,
  [quoteSlice.reducerPath]: quoteSlice.reducer,
  [countdownSlice.reducerPath]: countdownSlice.reducer,
  [permissionsApi.reducerPath]: permissionsApi.reducer,
  [feautureFlagApi.reducerPath]: feautureFlagApi.reducer,
  [featureFlagSlice.reducerPath]: featureFlagSlice.reducer,
  [showHighwayRegistrationFlowSlice.reducerPath]:
    showHighwayRegistrationFlowSlice.reducer,
  [permissionDialogSlice.reducerPath]: permissionDialogSlice.reducer,
});
